export interface TeamMemberInfo {
  name: string;
  title: string;
  bio: string;
}

export interface TeamMember {
  imageSrc: string;
  infoPl: TeamMemberInfo;
  infoEn: TeamMemberInfo;
}

export const teamMembers: ReadonlyArray<TeamMember> = [
  {
    imageSrc: "/team/lukasz.jpg",
    infoEn: {
      name: "Łukasz Osowski",
      title: "CEO, founder",
      bio: "He founded the IVONA company and later worked on Amazon Alexa speaking with IVONA voices currently used by 200M+ people in thousands of products. He holds multiple technology patents. He wants to help people live healthier and longer.",
    },
    infoPl: {
      name: "Łukasz Osowski",
      title: "CEO, założyciel",
      bio: "Założył firmę IVONA, a później tworzył asystenta głosowego Amazon Alexa mówiącego głosem IVONA, który jest używany przez setki milionów ludzi w tysiącach produktów. Jest autorem wielu patentów technologicznych. Chce, aby ludzie dłużej mogli cieszyć się zdrowiem.",
    },
  },
  {
    imageSrc: "/team/tomek.jpg",
    infoEn: {
      name: "Tomasz Noiński",
      title: "CTO, founder",
      bio: "Developer and manager of development teams. He used to work for Google as a Tech Lead of Gmail Site Reliability Engineering. Later, he moved to Amazon, working as a Software Development Engineer and Manager on Alexa and the Amazon state of the art Text-to-Speech engine.",
    },
    infoPl: {
      name: "Tomasz Noiński",
      title: "CTO, założyciel",
      bio: "Programista i kierownik zespołów programistycznych. Wcześniej pracował w Google, jako Tech Lead zespołu Gmail Site Reliability Engineering. Pracował też w Amazonie, jako programista i manager, współtworząc Amazon Alexa i napędzający ją syntezator mowy.",
    },
  },
  {
    imageSrc: "/team/piotrw.jpg",
    infoEn: {
      name: "Piotr Wiśniewski\nPhD, MD",
      title: "Chief Medical Officer, founder",
      bio: "Physician, researcher and academic teacher, board certified in Internal Medicine and Endocrinology. During over 15 years of practicing medicine he has often observed  that modern medicine places too little emphasis on prevention and healthy lifestyle promotion.",
    },
    infoPl: {
      name: "Dr n.med. Piotr Wiśniewski",
      title: "Dyrektor medyczny, założyciel",
      bio: "Lekarz endokrynolog, naukowiec i nauczyciel akademicki. W trakcie swojej ponad 15 letniej praktyki często zauważał, że współczesna medycyna przywiązuje zbyt małą wagę do kwestii profilaktyki i promocji zdrowego stylu życia.",
    },
  },
  {
    imageSrc: "/team/beata.jpg",
    infoEn: {
      name: "Beata Jackowska\nPhD, Assoc. Prof.",
      title: "Senior Modeling Specialist",
      bio: "Researcher and academic teacher in the Department of Statistics of the University of Gdansk and in the years of 2016-2023 a member of the Committee on Demographic Studies of the Polish Academy of Sciences. Her research work focuses on statistical, demographical and survival analysis methods as well as their applications in the analysis of mortality and in the assessment of economic and social risk.",
    },
    infoPl: {
      name: "dr hab. Beata Jackowska, prof. UG",
      title: "Specjalista Modelowania",
      bio: "Pracownik badawczo-dydaktyczny Katedry Statystyki Uniwersytetu Gdańskiego oraz w latach 2016-2023 członek Komitetu Nauk Demograficznych PAN. W swojej pracy badawczej koncentruje się nad metodami statystycznymi, demograficznymi oraz z zakresu analizy przeżycia i ich wykorzystaniem w analizie umieralności oraz do oceny ryzyka występującego w życiu ekonomiczno-społecznym.",
    },
  },
  {
    imageSrc: "/team/piotrb.jpg",
    infoEn: {
      name: "Piotr Bandosz\nPhD, MD",
      title: "Senior Modelling Specialist",
      bio: "Researcher, academic teacher and physician with significant experience in epidemiological modelling of noncommunicable diseases. Employee of the Medical University of Gdańsk and University of Liverpool. His main interest is modelling of the structural policies aimed to make populations more healthy.",
    },
    infoPl: {
      name: "Dr hab. med. Piotr Bandosz",
      title: "specjalista modelowania",
      bio: "Lekarz oraz pracownik naukowo-dydaktyczny. Posiada bogate doświadczenie w dziedzinie epidemiologii i modelowania chorób niezakaźnych. Pracownik Gdańskiego Uniwersytetu Medycznego oraz Uniwersytetu w Liverpoolu. Jego głównym zainteresowaniem jest modelowanie korzyści ze strukturalnych interwencji populacyjnych oddziaływujących na styl życia.",
    },
  },
  {
    imageSrc: "/team/robert.jpg",
    infoEn: {
      name: "Robert Różański\nPhD",
      title: "data scientist",
      bio: "Biotechnologist (MSc), philosopher (BA) and computer scientist (PhD). Since 2017 involved in R&D projects for industry.",
    },
    infoPl: {
      name: "dr Robert Różański",
      title: "spec. uczenia maszynowego",
      bio: "Z wykształcenia biotechnolog, filozof i informatyk. Od 2017 zaangażowany w projekty badawczo rozwojowe dla potrzeb przemysłu.",
    },
  },
  {
    imageSrc: "/team/jacek.jpg",
    infoEn: {
      name: " Jacek Rumiński\nAssoc. Prof., PhD, MSc",
      title: "Senior Science Advisor",
      bio: "He is a professor at the Gdańsk University of Technology specializing in the application of artificial intelligence in medicine and human-computer interaction methods. He is a head of the Department of Biomedical Engineering, and has over 200 scientific publications. Jacek supports initiatives related to the practical aspects of artificial intelligence.",
    },
    infoPl: {
      name: "dr hab. inż. Jacek Rumiński\nprof. PG",
      title: "Ekspert ds. Uczenia Maszynowego",
      bio: "Profesor Politechniki Gdańskiej specjalizujący się w zastosowaniu sztucznej inteligencji w medycynie oraz metodach interakcji człowiek-komputer. Kieruje Katedrą Inżynierii Biomedycznej, a w jego dorobku znajduje się ponad 200 publikacji naukowych. Wspiera inicjatywy związane z praktycznymi aspektami sztucznej inteligencji.",
    },
  },
  {
    imageSrc: "/team/anna.jpg",
    infoEn: {
      name: "Anna Słomkowska",
      title: "dietician, health writer&coach",
      bio: "Dietitian (M.Sc.), public health specialist and health educator. Since graduating in 2006, she has been helping her patients fight overweight and obesity related issues, along with diet-related diseases. Nutrition expert in health projects, radio and television programs. At Vika Life, she is responsible for writing texts and additionally implements the company's health policy.",
    },
    infoPl: {
      name: "Anna Słomkowska",
      title: "dietetyk, redaktor",
      bio: "Dietetyk, specjalista zdrowia publicznego i edukator zdrowotny. Od 2006 roku pomaga pacjentom w walce z nadwagą, otyłością i chorobami dietozależnymi.  Ekspert żywieniowy w projektach zdrowotnych, programach radiowych i telewizyjnych. W Vika Life odpowiada za opracowanie zdrowych nawyków i tekstów do aplikacji, a dodatkowo wdraża politykę zdrowotną w firmie.",
    },
  },
  {
    imageSrc: "/team/artur.jpg",
    infoEn: {
      name: "Artur Macholla",
      title: "UI designer",
      bio: "Specializing in UI design with 10 years of experience in working with businesses, start-ups and brands. Uses  design thinking to find best solutions. Holds degrees in IT and Arts. Passionate about design, space exploration and technology.",
    },
    infoPl: {
      name: "Artur Macholla",
      title: "UI designer",
      bio: "Specjalizuje się w projektowaniu UI. Od 2010 roku zdobywa doświadczenie współpracując z markami i startupami rozwiązując problemy zgodnie z metodologią Design Thinking. Pasjonuje się wszystkim co związane z projektowaniem, eksploracją kosmosu i technologią.",
    },
  },
  {
    imageSrc: "/team/monika.jpg",
    infoEn: {
      name: "Monika Janta",
      title: "UX designer",
      bio: "Graduated from the SWPS University (Psychology and UX Design). For over 5 years has been doing  user research and designing experiences according to human-centered design. Previously worked for one of the biggest Norwegian publishing houses researching and optimizing ecommerce and designing digital products for education.",
    },
    infoPl: {
      name: "Monika Janta",
      title: "UX designer",
      bio: "Absolwentka Uniwersytetu SWPS (Psychologia i UX Design). Od ponad 5 lat zajmuje się badaniami i tworzeniem doświadczeń zgodnych z celami i potrzebami użytkowników i biznesu. Wcześniej pracowała dla jednej z największych norweskich grup wydawniczych, gdzie badała i optymalizowała działanie sklepów internetowych oraz projektowała cyfrowe produkty edukacyjne.",
    },
  },
  {
    imageSrc: "/team/blanka.jpg",
    infoEn: {
      name: "Blanka Gniadecka",
      title: "Junior UX designer",
      bio: "BSc Anthropology graduate from University College London. The industry of mHealth technologies has sparked her interest during her studies in Digital Anthropology and Anthropology of Biomedicine. In her work, she pays significant attention to developing technologies from a stance based on awareness and ethics. Within the Vika team, Blanka is involved in communication, designing and modifying the app to improve user experience.",
    },
    infoPl: {
      name: "Blanka Gniadecka",
      title: "Junior UX designer",
      bio: "Absolwentka antropologii na University College London (BSc Anthropology). Przemysł technologii mHealth zainteresował Blankę podczas studiów w zakresie Digital Anthropology i Anthropology of Biomedicine. W swoim podejściu przywiązuje szczególną wagę do etycznego i świadomego tworzenia technologii. W Vice, Blanka zajmuje się komunikacją, projektowaniem oraz dostosowywaniem funkcjonalności aplikacji pod kątem użytkowym.",
    },
  },
  {
    imageSrc: "/team/kamil.jpg",
    infoEn: {
      name: "Kamil Rykowski",
      title: "Software Development Engineer",
      bio: "Software Engineer associated with web and mobile technologies since 2009. Publicly sharing his knowledge during workshops and technically-oriented conferences. Enthusiast of cross-platform solutions, especially Flutter.",
    },
    infoPl: {
      name: "Kamil Rykowski",
      title: "Software Development Engineer",
      bio: "Programista związany z technologiami webowymi i mobilnymi od 2009 roku. Publicznie dzieli się wiedzą podczas warsztatów i konferencji zorientowanych technologicznie. Entuzjasta rozwiązań cross-platformowych takich jak Flutter.",
    },
  },
  {
    imageSrc: "/team/jakub.jpg",
    infoEn: {
      name: "Jakub Trzebiatowski",
      title: "Software Development Engineer",
      bio: "Graduated from Gdansk University of Technology. Worked at Amazon Gdansk Development Center for more than one year as a Software Development Engineer Intern. His team was developing a core TTS framework and improving the language model development process. Passionate about computer science and software engineering.",
    },
    infoPl: {
      name: "Jakub Trzebiatowski",
      title: "Software Development Engineer",
      bio: "Absolwent Politechniki Gdańskiej. Wcześniej pracował nad syntezatorem mowy IVONA w Centrum Rozwoju Technologii w Gdańsku firmy Amazon na stanowisku Software Development Engineer Intern. Jego zespół rozwijał rdzeń silnika TTS oraz usprawniał proces tworzenia modeli językowych. Prywatnie pasjonat informatyki i technologii.",
    },
  },
  {
    imageSrc: "/team/rafal.jpg",
    infoEn: {
      name: "Rafał Krzemianowski\nPhD",
      title: "financial Manager",
      bio: "Project Manager with extensive experience in R&D project management. The Catholic University of Lublin graduate, where in 2016 has accomplished The Interdisciplinary PhD Studies. Huge basketball fan and tech enthusiast.",
    },
    infoPl: {
      name: "dr Rafał Krzemianowski",
      title: "manager finansowy",
      bio: "Absolwent Katolickiego Uniwersytetu Lubelskiego Jana Pawła II w Lublinie (2016). Absolwent stażu naukowego na Purdue University (IN, USA). Od 2010 naukowo i zawodowo związany projektami naukowo-badawczymi.",
    },
  },
];
